/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcWarningTriangleRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M10.824 8.748a1.178 1.178 0 1 1 2.351 0l-.292 4.92a.884.884 0 0 1-1.766 0zM10.5 17.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" />
      <path
        fillRule="evenodd"
        d="M14.544 2.78c-1.1-2.013-3.99-2.013-5.09 0L1.078 18.11c-1.056 1.932.343 4.29 2.545 4.29h16.756c2.202 0 3.6-2.358 2.544-4.29zm-3.51.863a1.1 1.1 0 0 1 1.93 0l8.379 15.33a1.1 1.1 0 0 1-.965 1.627H3.622a1.1 1.1 0 0 1-.965-1.627z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcWarningTriangleRegular;
